var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconocalendario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.67 40.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,13.56v-1.69C0,7.19,3.8,3.39,8.47,3.39h1.69v-1.69c0-.94.76-1.69,1.69-1.69s1.69.76,1.69,1.69v1.69h13.56v-1.69c0-.94.76-1.69,1.69-1.69s1.69.76,1.69,1.69v1.69h1.69c4.67,0,8.47,3.8,8.47,8.47v1.69H0Zm40.67,3.39v15.25c0,4.67-3.8,8.47-8.47,8.47H8.47c-4.67,0-8.47-3.8-8.47-8.47v-15.25h40.67Zm-10.45,5.34c-.65-.67-1.72-.69-2.4-.04l-8.06,7.76c-.64.64-1.71.68-2.44-.04l-3.86-3.59c-.68-.64-1.75-.6-2.39.09-.64.68-.6,1.76.09,2.39l3.82,3.54c.96.96,2.24,1.49,3.59,1.49s2.64-.53,3.57-1.47l8.03-7.74c.67-.65.69-1.72.04-2.4h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconocalendario);
export default __webpack_public_path__ + "static/media/icono calendario.30609f9b024a11f7d321d80b7ac4a9de.svg";
export { ForwardRef as ReactComponent };